require('./bootstrap');
require('admin-lte');
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
